import { type InitFlowComponent, sessionAtom, useIntl, useLogout, useSettings } from '@capsicum/common';
import { Button, Goat } from '@capsicum/common-web';
import { useMe } from '@capsicum/socios-core';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import styled from 'styled-components';

/**
 * Check if user is logged in and regulation is USA
 */
export const USUserDisabledFlow: InitFlowComponent = ({ fallback, next }) => {
	const { me } = useMe();
	const logout = useLogout();
	const { settings } = useSettings();
	const { $t } = useIntl();
	const session = useAtomValue(sessionAtom);

	useEffect(() => {
		if ((!session && me.regulation === undefined) || me.regulation === 'international') next();
	}, [me.regulation, session, next]);

	if (me.regulation === 'usa')
		return (
			<S.StyledGoat image="alert" testID="US-disabled-goat">
				<div>
					<S.Paragraph>{$t('auth.blockedCountry')}</S.Paragraph>
					<S.Paragraph>{$t('auth.contactCustomerCareIfNeed')}</S.Paragraph>
				</div>
				<S.ButtonWrapper>
					{settings ? (
						<a href={settings?.contactUsHereLinkForUsaCapsicum} rel="noopener noreferrer" target="_blank">
							<Button
								color="brand"
								testID="customer-care-button"
								text={$t('auth.contactUs')}
								variant="default"
							/>
						</a>
					) : (
						<Button
							color="brand"
							isLoading
							testID="customer-care-button"
							text={$t('auth.contactUs')}
							variant="default"
						/>
					)}
					<S.StyledButton
						color="brand"
						testID="register-with-another-phone-button"
						text={$t('auth.registerWithAnotherPhoneNumber')}
						variant="outlined"
						onClick={() => logout()}
					/>
				</S.ButtonWrapper>
			</S.StyledGoat>
		);

	return fallback;
};

USUserDisabledFlow.keepAlive = true;

namespace S {
	export const StyledGoat = styled(Goat)`
		padding: 10%;
	`;

	export const Paragraph = styled.p`
		${({ theme }) => theme.fonts.text.text3};
		text-align: center;
	`;

	export const ButtonWrapper = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.medium};
	`;

	export const StyledButton = styled(Button)`
		text-align: center;
	`;
}
